var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-wave"},[_c('div',{staticClass:"grid"},_vm._l((100),function(item){return _c('div',{key:item},[_c('div',{staticClass:"item",style:(("--i:" + item))})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }